import React from 'react';
import Typography from '@mui/material/Typography'; // Import Typography from MUI
import { Card, Grid, Box, useMediaQuery, Container, Avatar, CardContent } from '@mui/material';
import Mission from '../../assets/mission.png';
import Vission from '../../assets/vission.png';
import tagline from '../../assets/tagline.png';
import ai from '../../assets/ai.png';
import value from '../../assets/value.png';
import about from '../../assets/aboutus.png';
import network from '../../assets/network.png';
import web from '../../assets/webd.png';
import { faMicrochip } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AwesomeSlider from 'react-awesome-slider';
import image from "../../assets/techimage.png";
import rotateimage from "../../assets/rotate with image.png";
// import 'react-awesome-slider/styles.css';       
import 'react-awesome-slider/dist/styles.css';
import '../about/index.css'
import { width } from '@fortawesome/free-brands-svg-icons/fa42Group';
import Slider from './aboutslider';

const About = () => {
    const isLargeScreen = useMediaQuery('(min-width:2560px)');
    const isSmallScreen = useMediaQuery('(max-width:425px)');
    const isTabScreen = useMediaQuery('(max-width:768px)');
    const isMidScreen = useMediaQuery('(max-width:1024px)');
    const settings = {
        dots: true, // Show dots for navigation
        infinite: true, // Infinite scrolling
        speed: 500,
        slidesToShow: 1, // Show one card at a time
        slidesToScroll: 1, // Scroll one card at a time
    };
    return (
        <>
            <Card className='poppins-semibold' style={{ backgroundColor: "#0B77A8", borderRadius: "20px", padding: "22px", margin: "20px" }}>
                <Grid container spacing={4}>
                    <Grid item xs={8} sm={6} md={5} lg={5} xl={4}>
                        <Typography
                            variant='h3'
                            style={{
                                color: "white",
                                lineHeight: isLargeScreen ? 2.167 : "normal"
                            }}
                            sx={{
                                fontSize: {
                                    xl: "3rem",
                                    lg: "2.5rem",
                                    md: "2.2rem",
                                    sm: "1.7rem",
                                    xs: "1.2rem"
                                }
                            }}
                            className='poppins-semibold'
                        >
                            Together we are going to <Typography variant='h3' component='span'
                                style={{
                                    color: "white",
                                    lineHeight: isLargeScreen ? 2.167 : "normal"
                                }}
                                sx={{
                                    fontSize: {
                                        xl: "3rem",
                                        lg: "2.5rem",
                                        md: "2.2rem",
                                        sm: "1.7rem",
                                        xs: "1.2rem"
                                    }, background: "linear-gradient(92.73deg, #FFFFFF -9.53%, #F59C25 140.91%)",
                                    WebkitBackgroundClip: "text",
                                    WebkitTextFillColor: "transparent"
                                }}
                                className='poppins-semibold'>Innovate</Typography> to bring the best of technology
                        </Typography>
                    </Grid>

                    <Grid item xs={4} sm={6} md={7} lg={7} xl={8} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Box
                            component='img'
                            src={about}
                            sx={{
                                objectFit: "contain",
                                width: {
                                    xl: "35%",
                                    lg: "41%",
                                    md: "62%",
                                    sm: "70%",
                                    xs: "160%"
                                }, // Ensure it takes full width
                                // maxWidth: "400px", // Adjust max width as needed
                                height: "auto" // Maintain aspect ratio
                            }}
                        />
                    </Grid>
                    <Box
                        sx={{
                            backgroundColor: "white",
                            height: "2px",
                            width: "90%",
                            margin: "20px auto"
                        }}
                    />


                </Grid>
            </Card>
            <Container
                maxWidth="xxl"
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    marginTop: '50px',
                    marginBottom: '10px',
                    justifyContent: 'space-between', // Creates space between left and right items
                    padding: {
                        xs: '20px', // Smaller padding for mobile devices
                        sm: '30px', // Medium padding for small devices
                        md: '40px', // Larger padding for medium devices
                        lg: '50px', // Larger padding for large devices
                        xl: '50px'  // Consistent padding for extra-large devices
                    }
                }}
            >
                <Grid container spacing={5} sx={{ textAlign: 'center' }}>
                    {/* Heading section */}
                    <Grid
                        item
                        xs={12}
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            paddingTop: "70px",
                            paddingX: { xs: "10px", sm: "20px", md: "30px" }, // Responsive padding for left and right
                            textAlign: "center", // Center the text within the grid
                            maxWidth: "100%", // Ensures the grid item doesn't exceed the container width
                            flexWrap: "wrap", // Allows the text to wrap on smaller screens
                            overflow: "hidden", // Prevents overflow
                        }}
                    >
                        <Typography
                            variant='h4'
                            sx={{ color: "black", marginRight: "5px", flexShrink: 0 }} // Prevent shrinking
                            className='poppins-semibold'
                        >
                            Digital
                        </Typography>
                        <Typography
                            variant='h4'
                            sx={{ color: "#1166A6", flexShrink: 0 }} // Prevent shrinking
                            className='poppins-semibold'
                        >
                            Empowerment
                        </Typography>
                    </Grid>

                    {/* Paragraph section */}
                    <Grid item xs={12} sx={{ padding: { xs: '0 10px', sm: '0 20px', md: '0 30px' }, textAlign: "center" }}>
                        <Typography
                            component='p'
                            className='poppins-regular'
                            sx={{
                                fontSize: {
                                    xl: "1.5rem",
                                    lg: "1.5rem",
                                    sm: "1.2rem",
                                    xs: "0.8rem",
                                    md: "0.9rem" // Adjust for medium screens
                                },
                                color: "black",
                                margin: '0 auto', // Center the text block
                                // maxWidth: 'auto' // Limit width for better readability
                            }}
                        >
                            Edgology is a dynamic IT company at the forefront of educational technology.
                            We specialize in developing innovative software solutions that transform the way people learn and teach. Our mission is to empower learners of all ages with the tools and resources they need to succeed in the digital age. We are committed to providing high-quality, user-friendly products that meet the evolving needs of our customers.
                            Join us at Edgology and be part of a team that is shaping the future of education.
                        </Typography>
                    </Grid>
                </Grid>
            </Container>
            <section maxWidth={false} style={{ padding: '30px', marginBottom: '90px', position: 'relative', textAlign: 'center', paddingBottom: "60px", backgroundColor: "#F4F7FC" }} >
                <Typography
                    variant="h3"
                    // className="sixtyfour-convergence"
                    style={{
                        color: "#0B77A8",
                        paddingTop: "50px",
                        paddingBottom: "50px"
                    }}
                    className='poppins-semibold'
                >
                    What is our purpose
                </Typography>
                <Typography component='p' className='poppins-regular' sx={
                    {
                        fontSize: {
                            xl: "1.6rem",
                            lg: "1.3rem",
                            md: "1.2rem",
                            sm: "1rem",
                            xs: "0.9rem"
                        }
                    }
                }> Edgology is a dynamic IT company at the forefront of educational technology. We specialize in developing innovative software solutions that transform the way people learn and teach.
                    Our mission is to empower learners of all ages with the tools and resources they need to succeed in the digital age.
                    We are committed to providing high-quality, user-friendly products that meet the evolving needs of our customers.
                    Join us at Edgology and be part of a team that is shaping the future of education.</Typography>
            </section>
           
            <Container maxWidth={false} style={{ paddingTop: "90px", paddingBottom: "90px", backgroundColor: "#ECECEC", alignItems: "center", marginBottom: "50px" }}>
                <Card style={{ padding: "15px", backgroundColor: "rgb(11, 119, 168)", borderRadius: "25px" }}>
                    <Grid container spacing={4} style={{ marginBottom: "20px" }}>
                        <Grid item xs={12} sm={4}>
                            <Card style={{ borderRadius: "20px", marginTop: "10px", padding: "10px", height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                                <CardContent style={{ display: "flex", alignItems: "center" }}>
                                    <Avatar alt="Cindy Baker" src={Mission} style={{ marginRight: "10px" }} />
                                    <Typography variant='h5' className='poppins-semibold' sx={{
                                        fontSize: {
                                            xl: "2.5rem",
                                            lg: "2rem",
                                            md: "2rem",
                                            sm: "1.5rem",
                                            xs: "1.2rem"
                                        }
                                    }}>Mission</Typography>
                                </CardContent>
                                <Typography
                                    variant='h6'
                                    sx={{
                                        fontSize: {
                                            xl: "1.2rem",
                                            lg: "1rem",
                                            md: "0.8rem",
                                            sm: "0.7rem",
                                            xs: "0.8rem"
                                        }
                                    }}
                                    style={{
                                        width: "80%",
                                        marginLeft: "10px",
                                        wordWrap: "break-word",  // Ensure long words break onto new lines
                                        overflow: "hidden",
                                        textOverflow: "ellipsis", // Truncate if needed
                                        whiteSpace: "normal",  // Allow text to wrap
                                        maxWidth: "100%",  // Ensure it doesn't exceed the container

                                    }} className='poppins-regular'>

                                    Our mission is to help businesses of all sizes achieve their goals through the effective use of technology.
                                    We strive to provide reliable, scalable, and cost-effective solutions that drive growth and efficiency.
                                </Typography>
                            </Card>
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <Card style={{ borderRadius: "20px", marginTop: "10px", padding: "10px", height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                                <CardContent style={{ display: "flex", alignItems: "center" }}>
                                    <Avatar
                                        alt="Cindy Baker"
                                        src={Vission}
                                        style={{ marginRight: "10px" }}
                                        variant="rounded"  // For a rounded square shape
                                    />
                                    <Typography variant='h5' className='poppins-semibold' sx={{
                                        fontSize: {
                                            xl: "2.5rem",
                                            lg: "2rem",
                                            md: "2rem",
                                            sm: "1.5rem",

                                            xs: "1.2rem"
                                        }
                                    }} >Vission</Typography>
                                </CardContent>
                                <Typography
                                    variant='h6'
                                    sx={{
                                        fontSize: {
                                            xl: "1.2rem",
                                            lg: "1rem",
                                            md: "0.8rem",
                                            sm: "0.7rem",
                                            xs: "0.8rem"
                                        }
                                    }}
                                    style={{
                                        width: "80%",
                                        marginLeft: "10px",
                                        wordWrap: "break-word",  // Ensure long words break onto new lines
                                        overflow: "hidden",
                                        textOverflow: "ellipsis", // Truncate if needed
                                        whiteSpace: "normal",  // Allow text to wrap
                                        maxWidth: "100%",  // Ensure it doesn't exceed the container
                                    }} className='poppins-regular'>
                                    Our vision is to be a global leader in educational technology, providing innovative solutions that transform the way people learn and teach.
                                    We strive to create a world where learning is a lifelong journey, empowering individuals to reach their full potential.
                                </Typography>
                            </Card>
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <Card style={{ borderRadius: "20px", marginTop: "10px", padding: "10px", height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                                <CardContent style={{ display: "flex", alignItems: "center" }}>
                                    <Avatar alt="Cindy Baker" src={tagline} style={{ marginRight: "10px" }} />
                                    <Typography variant='h5' className='poppins-semibold' sx={{
                                        fontSize: {
                                            xl: "2.5rem",
                                            lg: "2rem",
                                            md: "2rem",
                                            sm: "1.5rem",
                                            xs: "1.2rem"
                                        }
                                    }} >Tag Line</Typography>
                                </CardContent>
                                <Typography
                                    variant='h6'
                                    sx={{
                                        fontSize: {
                                            xl: "1.2rem",
                                            lg: "1rem",
                                            md: "0.8rem",
                                            sm: "0.7rem",
                                            xs: "0.8rem"
                                        }
                                    }}
                                    style={{
                                        width: "80%",
                                        marginLeft: "10px",
                                        wordWrap: "break-word",  // Ensure long words break onto new lines
                                        overflow: "hidden",
                                        textOverflow: "ellipsis", // Truncate if needed
                                        whiteSpace: "normal",  // Allow text to wrap
                                        maxWidth: "100%",  // Ensure it doesn't exceed the container

                                    }} className='poppins-regular'>
                                    we're passionate about transforming the way people learn and teach. Our innovative software solutions empower learners of all ages with the tools and resources they need to succeed in the digital age. Join us on our journey to revolutionize education.
                                </Typography>
                            </Card>
                        </Grid>
                    </Grid>
                </Card>
            </Container>
            <Grid
                container
                justifyContent="center" // Centers content horizontally
                alignItems="center"     // Centers content vertically
                style={{
                    display: "flex",
                    paddingTop: "50px",
                    paddingBottom: "50px",
                    paddingLeft: "20px",
                    textAlign: "center"  // Ensures text is centered inside Typography
                }}
                spacing={5}
            >
                <Grid item xs={7} sm={6} md={6} lg={6}>
                    {/* xs={12} for full width on smaller screens, centered */}
                    <Typography variant='h3' className='poppins-semibold' sx={{
                        color: "rgb(33 33 33 / 72%);",
                        fontSize: isLargeScreen
                            ? "2.5rem"
                            : isSmallScreen
                                ? "0.7rem"
                                : isTabScreen
                                    ? "1.2rem"
                                    : isMidScreen
                                        ? "1.5rem"
                                        : "2rem",
                                        
                    }}>
                        At our core, we aim to revolutionize businesses with cutting-edge IT solutions that seamlessly integrate, enhance efficiency, and create transformative experiences, empowering clients to thrive in a dynamic digital future.
                    </Typography>
                </Grid>
                <Grid item xs={5} sm={6} md={6} lg={6} className='parent-container' style={{ display: "flex", justifyContent: "center" }}>
                    {/* Centers the image horizontally */}
                    <Box component='img'
                        src={rotateimage}
                        alt="Rotating Background"
                        className="rotate-image"
                        sx={{
                            width: {
                                xl: "31%",
                                lg: "42%",
                                md: "43%",
                                sm: "42%",
                                xs: "57%"
                            },
                            top: {
                                xl: "44%",
                                lg: "40%",
                                md: "50%",
                                sm: "50%",
                                xs: "51%"
                            }

                        }}
                    />
                    <Box component='img'
                        src={image}
                        alt="Main Image"
                        sx={
                            {
                                width: {
                                    xl: "41%",
                                    lg: "60%",
                                    md: "61%",
                                    sm: "49%",
                                    xs: "56%"
                                },
                                left: {
                                    xl: "18px",
                                    lg: "18px",
                                    md: "13px",
                                    xs: "-12px"
                                },
                                top: {
                                    xl: "71px",
                                    lg: "70px",
                                    md: "62px",
                                    sm: "21px",
                                    xs: "1px"
                                }
                            }
                        }
                        style={{ position: "relative", zIndex: 2 }}
                    />
                </Grid>
            </Grid>
            <Grid container spacing={4} style={{paddingBottom:"50px",justifyContent: "center",paddingTop:"20px"}}>
                <Grid item xs={6} sm={6} md={5} lg={5} >
                    <Box
                        component='img'
                        src={value}
                        width='100%'
                        style={{ borderRadius: '70%' }}  // Makes the image round
                    />
                </Grid>
                <Grid item xs={10} sm={6} md={5} lg={5} container style={{display:"block"}} alignItems="left">
                    {/* <Typography variant='h4' style={{ color: "#0B77A8", marginBottom: '10px' }}>
                        Our Value's
                    </Typography> */}
                    <Typography component='div' style={{marginBottom: '10px',display:"flex"}} alignItems="left">
                    <Typography variant='h4' style={{ color: "black", marginRight: "5px" }} className='poppins-semibold'>
                        OUR
                    </Typography>
                    <Typography variant='h4' style={{ color: "#1166A6" }} className='poppins-semibold'>
                        VALUE'S
                    </Typography>
                </Typography>
                    <Typography component='p' style={{ color: "#6A6A6A", marginBottom: '20px', marginTop: "2px" }}>
                        Our core values fuel our commitment to success, fostering trust and innovation in all we do.
                    </Typography>
                   
                    <Slider />
                </Grid>
            </Grid>
            <Container
    maxWidth={false}
    style={{
        backgroundColor: "rgb(225 225 225)",
        display: 'flex',
        flexDirection: 'column',
        paddingTop: "30px", // Reduced padding for small screens
        paddingBottom: "50px" // Reduced padding for small screens
    }}
>
    <Box style={{ width: '100%', padding: '0 20px' }}> {/* Adjusted padding for smaller screens */}
        <Typography variant="h3" component='div' style={{ display: "flex", textAlign: 'left' }}>
            <Typography
                variant='h4'
                sx={{
                    fontSize: {
                        xl: "2.5rem",
                        lg: "2rem",
                        md: "2rem",
                        sm: "1.5rem",
                        xs: "1.5rem" // Adjusted size for extra small screens
                    }
                }}
                style={{ color: "black", marginRight: "5px" }} className='poppins-semibold'>
                OUR
            </Typography>
            <Typography
                variant='h4'
                sx={{
                    fontSize: {
                        xl: "2.5rem",
                        lg: "2rem",
                        md: "2rem",
                        sm: "1.5rem",
                        xs: "1.5rem" // Adjusted size for extra small screens
                    }
                }}
                style={{ color: "#1166A6" }} className='poppins-semibold'>
                EXPERTISE
            </Typography>
        </Typography>
        <Typography
            variant="body1"
            className='poppins-regular'
            gutterBottom
            sx={{
                textAlign: 'left',
                color: "#727171",
                marginTop: "10px",
                fontSize: {
                    xl: "1.5rem",
                    lg: "1rem",
                    md: "1.1rem",
                    sm: "1rem",
                    xs: "0.9rem" // Adjusted size for extra small screens
                }
            }}
        >
            With deep expertise in cutting-edge software technologies, we deliver innovative solutions, robust applications, and seamless user experiences to clients worldwide.
        </Typography>

        {/* Expertise Boxes */}
        {[
            {
                avatar: ai,
                title: "Artificial Intelligence",
                description: "Advanced AI solutions driving growth, smart automation, data-driven insights, enhanced experiences across industries."
            },
            {
                avatar: network,
                title: "Distributed Networking",
                description: "Scalable, innovative networking services for data storage, collaboration, and app delivery in diverse industries."
            },
            {
                avatar: web,
                title: "Website Development",
                description: "Creating functional and visually appealing websites to enhance online presence, user experience, and business growth."
            }
        ].map((item, index) => (
            <Box
                key={index}
                mt={4}
                style={{
                    paddingLeft: "10px", // Adjusted padding for smaller screens
                    textAlign: 'left',
                    display: "flex",
                    border: "2px solid #0B77A8",
                    borderRadius: "15px",
                    backgroundColor: "white",
                    paddingTop: "5px",
                    paddingBottom: "5px" // Added padding for visual balance
                }}
            >
                <Avatar src={item.avatar} style={{ marginRight: "10px" }} />
                <div>
                    <Typography
                        variant="h5"
                        className='poppins-semibold'
                        gutterBottom
                        sx={{
                            fontSize: {
                                xl: "1.7rem",
                                lg: "1.3rem",
                                md: "1.2rem",
                                sm: "1.2rem",
                                xs: "1rem" // Adjusted size for extra small screens
                            }
                        }}
                        style={{ display: "flex", alignItems: "center" }}
                    >
                        {item.title}
                    </Typography>
                    <Typography
                        variant="body1"
                        gutterBottom
                        className='poppins-regular'
                        sx={{
                            fontSize: {
                                xl: "1.5rem",
                                lg: "1rem",
                                md: "0.9rem",
                                sm: "0.7rem",
                                xs: "0.8rem"
                            }
                        }}
                    >
                        {item.description}
                    </Typography>
                </div>
            </Box>
        ))}
    </Box>
</Container>


        </>
    );
};

export default About;
